function SpecialConditionController($scope) {
  const ctrl = this;

  ctrl.$onInit = function() {
    ctrl.types = [
      // { type: 'Duration', value: 'DURATION', disabled: false },
      { type: 'Speed', value: 'SPEED', disabled: false },
      { type: 'Location', value: 'LOCATION', disabled: false },
    ];
    ctrl.operators = ['greater than', 'less than'];
    ctrl.locations = ['in depot', 'not in depot'];
    if (ctrl.viewMode) {
      ctrl.editMode = false;
    } else {
      ctrl.editMode = true;
    }
  };

  ctrl.$onChanges = function(changes) {
    if (changes.newSpecialCondition) {
      ctrl.newSpecialCondition = angular.copy(ctrl.newSpecialCondition);
    }
  };

  ctrl.removeCondition = function() {
    ctrl.onRemove({
      $event: {
        conditionIndex: ctrl.index,
      },
    });
  };

  ctrl.saveCondition = function() {
    if (ctrl.index > 0) {
      ctrl.newSpecialCondition.relationToPrevious = 'and';
    }
    ctrl.editMode = false;
    ctrl.onSave({
      $event: {
        conditionIndex: ctrl.index,
        newSpecialCondition: ctrl.newSpecialCondition,
      },
    });
  };

  ctrl.enableEdit = function() {
    ctrl.editMode = true;
    ctrl.onEdit();
  };
}

angular
  .module('psa.module')
  .controller('SpecialConditionController', SpecialConditionController);
